import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { QrcodeComponent } from '@app/components/qrcode/qrcode.component';

@Component({
  selector: 'app-page-reserve-table',
  templateUrl: './reserve-table.component.html',
  styleUrl: './reserve-table.component.scss',
  imports: [
    PageHeaderComponent,
    QrcodeComponent,
    QrcodeComponent,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReserveTableComponent {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };
}
